import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface NetworkAlertsState {
  /** Last successful `data.active` from GET `/kontroledge/network-events/count`. */
  activeCount: number | null;
  /** Tenant this count belongs to; mismatch → treat as unknown until next success. */
  countTenantId: number | null;
}

const initialState: NetworkAlertsState = {
  activeCount: null,
  countTenantId: null,
};

const networkAlertsSlice = createSlice({
  name: "networkAlerts",
  initialState,
  reducers: {
    setNetworkEventsActiveCountSuccess(
      state,
      action: PayloadAction<{ tenantId: number; active: number }>
    ) {
      state.activeCount = action.payload.active;
      state.countTenantId = action.payload.tenantId;
    },
    clearNetworkEventsActiveCount(state) {
      state.activeCount = null;
      state.countTenantId = null;
    },
  },
});

export const {
  setNetworkEventsActiveCountSuccess,
  clearNetworkEventsActiveCount,
} = networkAlertsSlice.actions;

export default networkAlertsSlice.reducer;
